export default (value: boolean) => {
    return value ? "Yes": "No";
} 